module.exports = __webpack_public_path__ + "img/sky-confirmation.34c47602.png";